import { TagsCustomModelsModel } from '../../../domain/models'

import * as S from './styles'

type HelperSidebarItemProps = {
  item: TagsCustomModelsModel
}

const HelperSidebarItem = ({ item }: HelperSidebarItemProps) => {
  return (
    <S.SidebarContentDropdown className="sidebar-content-dropdown">
      <div>
        {item.descricao} - <span>{item.legenda}</span>
      </div>
    </S.SidebarContentDropdown>
  )
}

export default HelperSidebarItem
